import { render, staticRenderFns } from "./PayOrDraw.vue?vue&type=template&id=9028af7e&scoped=true&"
import script from "./PayOrDraw.vue?vue&type=script&lang=js&"
export * from "./PayOrDraw.vue?vue&type=script&lang=js&"
import style0 from "./PayOrDraw.vue?vue&type=style&index=0&id=9028af7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9028af7e",
  null
  
)

export default component.exports